import React, { useState } from "react";
import "../Profile/Profile.css";
import cupIconSrc from "../../assets/cupIconSrc";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://api-2026.fikacreatives.co";

const OPTIONS = [
  { value: "1x_week",    cups: 1, label: "1x / week" },
  { value: "2x_month",   cups: 2, label: "2x / month" },
  { value: "occasional", cups: 3, label: "Occasional" },
];

export default function CoffeeFrequencyModal({ onClose, onSaved }) {
  const [saving, setSaving] = useState(false);

  async function handleSelect(value) {
    if (saving) return;
    setSaving(true);
    onSaved();
    fetch(`${API_BASE}/api/onboarding`, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "save_step", coffee_frequency: value }),
    }).catch(() => {});
  }

  return (
    <div className="pInviteOverlay" onClick={onClose}>
      <div className="nbhdModal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <button className="pInviteClose" onClick={onClose} aria-label="Close">✕</button>

        <div className="nbhdBody">
          <div className="nbhdPin">☕</div>
          <h2 className="nbhdTitle">How often would you like to Fika?</h2>
          <p className="nbhdSub">
            How many times per month would you like to meet new creatives over coffee?
          </p>

          <div style={{ display: "flex", gap: 12, marginTop: 24, width: "100%" }}>
            {OPTIONS.map(({ value, cups, label }) => (
              <button
                key={value}
                type="button"
                disabled={saving}
                onClick={() => handleSelect(value)}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 14,
                  padding: "24px 10px 18px",
                  border: "1.5px solid #e0d9d0",
                  borderRadius: 16,
                  background: "#faf9f7",
                  cursor: saving ? "default" : "pointer",
                  fontFamily: "inherit",
                  opacity: saving ? 0.6 : 1,
                  transition: "border-color 0.15s ease, background 0.15s ease",
                }}
              >
                <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
                  {Array.from({ length: cups }).map((_, i) => (
                    <img key={i} src={cupIconSrc} alt="" style={{ width: 30, height: 30, objectFit: "contain" }} />
                  ))}
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e", letterSpacing: "0.01em" }}>
                  {label}
                </span>
              </button>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
